import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps, stepLabels }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ color: '#2E7D32', fontWeight: 'bold' }}>
          Step {currentStep} of {totalSteps}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {Math.round(progress)}% Complete
        </Typography>
      </Box>
      
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: '#e0e0e0',
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#2E7D32',
            borderRadius: 4,
          },
        }}
      />
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
        {stepLabels.map((label, index) => (
          <Typography
            key={index}
            variant="caption"
            sx={{
              color: index < currentStep ? '#2E7D32' : 'text.secondary',
              fontWeight: index < currentStep ? 'bold' : 'normal',
              textAlign: 'center',
              flex: 1,
            }}
          >
            {label}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default ProgressBar;
